import {withRouter} from 'react-router-dom';
import {Breadcrumb, Col, Container, Row} from 'react-bootstrap';
import {useEffect, useState} from "react";
import Api from "../../services/Api";
import HelperGeneral from "../../helpers/HelperGeneral";
import {Spin} from "antd";
import ReactHtmlParser from "react-html-parser";
import UserInfo from "../auth/UserInfo";

const Information = (props) => {
    const [loading, setLoading] = useState(false);
    const [informationData, setInformationData] = useState([]);

    const url = props?.match?.url;
    let title = "";
    let type = 21;

    if (url === "/about" || url === "/hakkimizda") {
        title = "Hakkımızda";
    } else if (url === "/kvkk" || url === "/kvkk-aydinlatma-metni") {
        title = "KVKK Aydınlatma Metni";
        type = 6;
    } else if (url === "/explicit_consent_statement" || url === "/acik-riza-beyani") {
        title = "Açık Rıza Beyanı";
        type = 5;
    } else if (url === "/sss") {
        title = "Sıkça Sorulan Sorular";
        type = 19;
    } else if (url === '/ticari-elektronik-ileti'){
        title = "Ticari Elektronik İleti Bilgilendirme Metni";
        type = 37;
    }

    useEffect(() => {
        getInformation();

        if (url === "/sss" && UserInfo.info('user_roles_id') === 3) {
            HelperGeneral.pageChange(props, '/dokumanlar/sss')
        }
    }, []);

    const getInformation = () => {
        setLoading(true);
        Api.getOtherPages().then((e) => {
            setLoading(false);
            setInformationData(e?.data);
        }).catch(e => {
            HelperGeneral.alert(e);
            setLoading(false);
        })
    }

    return (
        <div className={'my-account product-category info pb-2 pb-sm-4 min-height-container'}>
            <Container>
                <Row>
                    <Col xs={12}>
                        <h4>{title}</h4>
                        <Breadcrumb>
                            <Breadcrumb.Item href={"/home"}>Ana Sayfa</Breadcrumb.Item>
                            <Breadcrumb.Item active={true}>{title}</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Col xs={12} className={'mt-1 mt-sm-4'}>
                        <Spin spinning={loading}>
                            {informationData.find((data) => data?.id === type)?.description ? ReactHtmlParser(informationData.find((data) => data?.id === type)?.description) : ''}
                        </Spin>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default withRouter(Information);
